/* eslint-disable react/display-name */
import { Fragment, memo } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Datepicker, HookForm, Number } from '@dec/shared';
import { BtnGroup, BtnToolbar, Col, Row } from '@dec/shared';
import { notificationSuccess } from 'app/core/toast';
import i18next from 'i18next';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { ConfirmDialog } from '../../../../../../core/dialog';
import { label as labelCommon } from '../../../../../translation';
import { useReport } from '../../../services/hooks';
import { create, remove, update } from '../http';
import { label, messages } from '../Translate/translation';
import { type ReportVersion } from '../types';

const fieldRequired = 'common.validations.fieldRequired';
const validations = yup.object().shape({
  version: yup.number().nullable().required(i18next.t(fieldRequired)),
  dateFrom: yup.date().required(i18next.t(fieldRequired)),
  dateTo: yup.date().nullable().notRequired()
});

interface Props {
  defaultValue: ReportVersion;
}
const Index = memo(({ defaultValue }: Props) => {
  const { data } = useReport(defaultValue.reportId as string);
  const redirectRoute = `/taxes/manage/complementary/${defaultValue.reportId}/general`;
  const navigate = useNavigate();
  const onCancel = () => {
    navigate(redirectRoute);
  };
  const { t, i18n } = useTranslation();
  const save = async (model: ReportVersion) => {
    model.id = defaultValue?.id;
    model.reportId = defaultValue.reportId;
    try {
      if (model.id) {
        await update(model.id, model);
      } else {
        await create(model);
      }
      notificationSuccess(i18next.t('taxes.messages.savedSuccessfully'));
      navigate(redirectRoute);
    } catch (e) {
      console.error(e);
    }
  };
  if (!data) {
    return <></>;
  }

  return (
    <Fragment>
      <HookForm initialValues={defaultValue} validations={validations} onSubmit={save}>
        <Row>
          <Col>
            <Form.Label>{label('formCode')}</Form.Label>
            <h3>{data.code}</h3>
          </Col>
          <Col>
            <Form.Label>{label('formName')}</Form.Label>
            <h3>{data.name}</h3>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <Number label={label('version')} name="version" />
          </Col>
        </Row>
        <Row>
          <Col>
            <Datepicker label={label('startDate')} name="dateFrom" />
          </Col>
          <Col>
            <Datepicker label={label('endDate')} name="dateTo" />
          </Col>
        </Row>
        <BtnToolbar>
          <BtnGroup>
            <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
            <Button
              visible={defaultValue?.id !== undefined}
              action={ButtonAction.delete}
              variant={'danger'}
              onClick={async () => {
                const ok = await ConfirmDialog({
                  titleModal: messages('confirmTitle'),
                  message: messages('confirmDeleted'),
                  okButton: labelCommon('ok'),
                  cancelButton: labelCommon('cancel')
                });
                if (ok) {
                  try {
                    await remove(defaultValue.id as string);
                    notificationSuccess(i18next.t('taxes.messages.deletedSuccessfully'));
                    navigate(redirectRoute);
                  } catch (e) {
                    console.error(e);
                  }
                }
              }}
            />
          </BtnGroup>
          <BtnGroup>
            <Button action={ButtonAction.save} variant="primary" type={'submit'} />
          </BtnGroup>
        </BtnToolbar>
      </HookForm>
    </Fragment>
  );
});

export default Index;
